import { render, staticRenderFns } from "./SourcesView.vue?vue&type=template&id=3af52854&scoped=true"
import script from "./SourcesView.vue?vue&type=script&lang=js"
export * from "./SourcesView.vue?vue&type=script&lang=js"
import style0 from "./SourcesView.vue?vue&type=style&index=0&id=3af52854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af52854",
  null
  
)

export default component.exports